export default (event, funnelName, subFunnelName, referredAdn = null ) => {
  return {
    'event': event,
    'funnel_name': funnelName,
    'sub_funnel_name': subFunnelName,
    'referred_adn': referredAdn ? referredAdn : 'NA',
  };
};